import React from "react";

import { FiFileText, FiPackage } from "react-icons/fi";
import { BsFillPeopleFill } from "react-icons/bs";
import { GrUserWorker } from "react-icons/gr";
import { MdOutlinePayments } from "react-icons/md";
import { MdOutlineSos } from "react-icons/md";
import { HiOutlineDotsHorizontal } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { MdOutlineConstruction } from "react-icons/md";
import { TbBuildingCottage } from "react-icons/tb";
import { CiDeliveryTruck } from "react-icons/ci";
import { TbAlertSquareFilled } from "react-icons/tb";
import { TbReport } from "react-icons/tb";
import { FaPeoplePulling } from "react-icons/fa6";
import { TbTruckDelivery } from "react-icons/tb";
import { useSelector } from "react-redux";
import { MdOutlineInventory2 } from "react-icons/md";
import { RiWaterPercentFill } from "react-icons/ri";
import { IoIosArrowForward } from "react-icons/io";
import { FaClock } from "react-icons/fa";
import { FaTruck } from "react-icons/fa";
import { FaBasketballBall } from "react-icons/fa";
import { MdEngineering } from "react-icons/md";
import { GrDocumentConfig } from "react-icons/gr";

export default function SecurityAppicons() {
  const currentUser = useSelector((state) => state.userObject);
  const navigate = useNavigate();

  const requestTypes = [
    {
      label: "Guests",
      icon: <BsFillPeopleFill />,
      link: "/guests",
      roles: ["admin", "security", "reception", "security-guard", "mst"],
    },
    {
      label: "Parcels",
      icon: <FiPackage />,
      link: "/parcels",
      roles: ["admin", "housekeeping", "reception", "security"],
    },
    {
      label: "Inventory",
      icon: <MdOutlineInventory2 />,
      link: "/inventory",
      roles: ["admin", "housekeeping", "reception"],
    },
    {
      label: "Gate Pass",
      icon: <FaTruck />,
      link: "/gate-pass",
      roles: ["admin", "security", "reception", "security-guard", "mst"],
    },
    {
      label: "Service Requests",
      icon: <MdOutlineConstruction />,
      link: "/service-requests",
      roles: ["admin", "security", "security-guard", "reception", "mst"],
    },
    {
      label: "Water Reading",
      icon: <RiWaterPercentFill />,
      link: "/water-meter-reading",
      roles: ["admin", "security", "reception", "mst"],
    },
    {
      label: "Permits",
      icon: <GrDocumentConfig />,
      link: "/work-permits",
      roles: ["admin", "security", "mst"],
    },
    {
      label: "Facilities",
      icon: <FaBasketballBall />,
      link: "/facility-usage",
      roles: ["admin", "security", "mst"],
    },
    {
      label: "Concerns",
      icon: <MdEngineering />,
      link: "/concerns",
      roles: ["admin", "security", "reception", "housekeeping", "mst"],
    },
    {
      label: "Incidents",
      icon: <FaPeoplePulling />,
      link: "/incidents",
      roles: ["admin", "security", "mst"],
    },
    {
      label: "Alerts",
      icon: <TbAlertSquareFilled />,
      link: "/alerts",
      roles: ["admin", "security", "reception"],
    },
    {
      label: "Clock In/Out",
      icon: <FaClock />,
      link: "/clock-in-out",
      roles: ["admin", "security", "reception", "housekeeping", "all"],
    },
  ];

  const filteredRequestTypes = requestTypes.filter((request) =>
    currentUser.roles?.some((role) => request.roles?.includes(role))
  );

  return (
    <div className="bg-white rounded-xl shadow-sm px-4 py-5 mt-2">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-sm font-semibold text-[#363062]">Services</h2>
      </div>

      <div className="grid grid-cols-4 gap-4">
        {filteredRequestTypes.map((request, index) => (
          <div
            key={index}
            onClick={() => navigate(`${request.link}`)}
            className="flex flex-col items-center cursor-pointer transition-transform active:scale-95 h-18"
          >
            <div className="text-4xl text-eleghoBlue mb-1">{request.icon}</div>
            <span className="text-[10px] font-medium text-center text-gray-700 mt-1">
              {request.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
